// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9d3c3ff2","239":"cc8da08f","732":"9a8aa2cf"}[chunkId] + ".chunk.js";
};